import type { ClassNameValue } from 'tailwind-merge';
// import emailjs from '@emailjs/browser';
import { useStore } from '@tanstack/react-store';
import { CornerDownRightIcon } from 'lucide-react';
import { data } from '~/data/basic';
import { langStore } from '~/store/langStore';
import { cn } from '~/utils';
import { storeData } from '~/utils/airtable';
import LayeredButton from './LayeredButton';

export default function Contact({ className }: { className?: ClassNameValue }) {
  const locale = useStore(langStore, s => s);

  const send = data.contact.send[locale];
  const name = data.contact.name[locale];
  const message = data.contact.message[locale];
  const question = data.contact.question[locale];
  const write = data.contact.write[locale];

  return (
    <div className={cn([
      // 'font-inter',
      'flex',
      'py-15',
      'text-white',
      'justify-center',
      'md:justify-around',
      'items-center',
      'lg:items-start',
      'flex-col',
      'mx-auto',
      'lg:gap-16',
    ], className)}
    >
      <div className="flex flex-col gap-2 text-center lg:gap-10 lg:text-left">
        <div className="text-orange text-4xl font-bold lg:text-6xl">
          {question}
        </div>
        <div className="text-red mb-5 text-4xl font-bold lg:mb-2 lg:text-5xl ">
          {write}
        </div>
        <div>
          <CornerDownRightIcon className="mr-2 hidden lg:inline" />
          {data.contactEmail}
        </div>
      </div>
      <div>
        <form
          onSubmit={async (event) => {
            event.preventDefault();
            const t = event.currentTarget;
            const fd = new FormData(t);
            const _response = await storeData({
              data: {
                name: fd.get('name') as string,
                message: fd.get('msg') as string,
                email: fd.get('email') as string,
              },
            });
            t.reset();
          }}
        >
          <div className="mt-8 flex flex-col justify-center md:items-center">
            <div className="flex flex-col gap-2 md:items-center lg:flex-row">

              <input
                type="email"
                name="email"
                placeholder="Email"
                className="text-yellow bg-white p-2"
              />
              <input
                type="text"
                name="name"
                placeholder={name}
                className="text-yellow bg-white p-2"
              />
            </div>
            <textarea
              name="msg"
              placeholder={message}
              className="text-yellow mt-2 w-full resize-none bg-white p-2"
            />
            <LayeredButton
              type="submit"
              className="m-2.5 self-center"
              text={send}
            />
          </div>
        </form>
      </div>
    </div>
  );
}
